<template>
  <button @click="onClick" :class="`button`">
    <slot />
  </button>
</template>
<script>
export default {
  name: "Button",
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="css">
@import "index.module.css";
</style>
